import api from './../api';

export default {
    getTags: async (withResponse = false, defaultResponse = null) => {
        let response = await api
            .get('/tags')
            .then((res) => res)
            .catch((err) => err.response);

        return withResponse
            ? response
            : response.status === 200
            ? response.data
            : defaultResponse;
    },

    getTag: async (tag_id, withResponse = false, defaultResponse = null) => {
        let response = await api
            .get(`/tag/${tag_id}`)
            .then((res) => res)
            .catch((err) => err.response);

        return withResponse
            ? response
            : response.status === 200
            ? response.data
            : defaultResponse;
    },
};
